import { render, staticRenderFns } from "./fundraisers.vue?vue&type=template&id=1a4bb92e&scoped=true"
import script from "./fundraisers.vue?vue&type=script&lang=ts"
export * from "./fundraisers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bb92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4bb92e')) {
      api.createRecord('1a4bb92e', component.options)
    } else {
      api.reload('1a4bb92e', component.options)
    }
    module.hot.accept("./fundraisers.vue?vue&type=template&id=1a4bb92e&scoped=true", function () {
      api.rerender('1a4bb92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/fundraisers/fundraisers.vue"
export default component.exports